var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0604 8.22188C18.9225 8.32988 16.4877 9.71468 16.4877 12.7939C16.4877 16.3555 19.5859 17.6155 19.6786 17.6467C19.6644 17.7235 19.1864 19.3723 18.0451 21.0523C17.0274 22.5307 15.9646 24.0067 14.3477 24.0067C12.7309 24.0067 12.3148 23.0587 10.4482 23.0587C8.62925 23.0587 7.9825 24.0379 6.50355 24.0379C5.02459 24.0379 3.99265 22.6699 2.80615 20.9899C1.43182 19.0171 0.321411 15.9523 0.321411 13.0435C0.321411 8.37788 3.32688 5.90348 6.28479 5.90348C7.85648 5.90348 9.16662 6.94508 10.1534 6.94508C11.0926 6.94508 12.5573 5.84108 14.3453 5.84108C15.023 5.84108 17.4578 5.90348 19.0604 8.22188ZM13.4965 3.86588C14.236 2.98028 14.7591 1.75148 14.7591 0.522683C14.7591 0.352283 14.7448 0.179483 14.7139 0.0402832C13.5108 0.0858832 12.0794 0.849083 11.2162 1.85948C10.5386 2.63708 9.9061 3.86588 9.9061 5.11148C9.9061 5.29868 9.93701 5.48588 9.95128 5.54588C10.0274 5.56028 10.151 5.57708 10.2746 5.57708C11.3541 5.57708 12.7118 4.84748 13.4965 3.86588Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApple);
export default __webpack_public_path__ + "static/media/logo-apple.c05efa2c30f50da1a86ade7d68a0301d.svg";
export { ForwardRef as ReactComponent };